import { ResultOf } from "gql.tada";
import { GetStartedSectionById } from "../../../queries/entries/GetStartedSectionById";
import { BackgroundBlob } from "../../shared/BackgroundBlob";

export const GetStartedSubmission = ({
  entry,
}: {
  entry: ResultOf<typeof GetStartedSectionById>["getStartedSection"];
}) => {
  return (
    <section className="relative min-h-[calc(100vh-200px)] flex items-center justify-center">
      <BackgroundBlob />
      <div className="container-base">
        <div className="max-w-[800px] mx-auto text-center">
          <div className="text-title-heading">{entry?.submittedTitle}</div>
          <div className="text-body-regular my-10">{entry?.submittedNote}</div>
        </div>
      </div>
    </section>
  );
};